"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var utils_1 = require("./utils");

var defaultOptions = {
  pure: true,
  withStore: false
};

function createConnect(mapStateToProps, actions, mergedProps, options) {
  if (mapStateToProps === void 0) {
    mapStateToProps = null;
  }

  if (actions === void 0) {
    actions = null;
  }

  if (mergedProps === void 0) {
    mergedProps = {};
  }

  if (options === void 0) {
    options = defaultOptions;
  }

  var _a = __assign({}, defaultOptions, options),
      pure = _a.pure,
      withStore = _a.withStore,
      providedStore = _a.store,
      storeKey = _a.storeKey;

  if (!utils_1.isFn(mapStateToProps)) {
    mapStateToProps = utils_1.select(mapStateToProps || []);
  }

  var internalStoreKey = storeKey || utils_1.defaultStoreKey;
  var OuterBaseComponent = pure ? React.PureComponent : React.Component;
  return function (Child) {
    var _a;

    var wrappedComponentName = Child.displayName || Child.name || 'Component';

    function Wrapper(props, context) {
      var _this = this;

      OuterBaseComponent.call(this, props, context);
      var store = providedStore || context[internalStoreKey];
      var boundActions = actions ? utils_1.mapActions(actions, store) : {
        store: store
      };
      var state = mapStateToProps(store ? store.getState() : {}, props);

      var update = function update() {
        var mapped = mapStateToProps(store ? store.getState() : {}, _this.props);

        for (var i in mapped) {
          if (mapped[i] !== state[i]) {
            state = mapped;
            return _this.forceUpdate();
          }
        }

        for (var i in state) {
          if (!(i in mapped)) {
            state = mapped;
            return _this.forceUpdate();
          }
        }
      };

      this.componentDidMount = function () {
        store && store.subscribe(update);
      };

      this.componentWillUnmount = function () {
        store && store.unsubscribe(update);
      };

      this.render = function () {
        var connectedMergedProps = __assign({}, __assign({}, boundActions), _this.props, state, mergedProps);

        var store = connectedMergedProps.store,
            propsWithoutStore = __rest(connectedMergedProps, ["store"]);

        var preparedProps = withStore ? connectedMergedProps : propsWithoutStore;
        return React.createElement(Child, __assign({}, preparedProps, mergedProps));
      };
    }

    Wrapper.displayName = "Connect(" + wrappedComponentName + ")";
    Wrapper.contextTypes = (_a = {}, _a[utils_1.defaultStoreKey] = function () {}, _a);
    return (Wrapper.prototype = Object.create(OuterBaseComponent.prototype)).constructor = Wrapper;
  };
}

exports.createConnect = createConnect;
exports.default = createConnect;